import { render, staticRenderFns } from "./scorecard-edit-order.vue?vue&type=template&id=1dd473b8&scoped=true"
import script from "./scorecard-edit-order.vue?vue&type=script&lang=js"
export * from "./scorecard-edit-order.vue?vue&type=script&lang=js"
import style0 from "./scorecard-edit-order.vue?vue&type=style&index=0&id=1dd473b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd473b8",
  null
  
)

export default component.exports